{
  "eyebrow": "Conferma il tuo piano",
  "title": "Rivedi e configura.",
  "sub": "Puoi cambiare il ciclo di fatturazione o il piano in qualsiasi momento dalla dashboard amministratore.",
  "yourPlan": "Il tuo piano",
  "changePlan": "Cambia piano",
  "billing": "Ciclo di fatturazione",
  "billingMonthLabel": "Pagamento mensile",
  "billingMonthDesc": "Flessibile. Annulla quando vuoi.",
  "billingYearLabel": "Pagamento annuale",
  "billingYearDesc": "~17% di sconto. Fatturato una volta l'anno.",
  "addons": "Componenti aggiuntivi",
  "addon": {
    "ssec": "Sicurezza sociale (check-in/out@work)",
    "ssecDesc": "Solo Belgio — dichiarazione Dimona automatica.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS live per i veicoli aziendali. +4 €/veicolo/mese.",
    "vehicles": "Veicoli",
    "projectAddon": "Componente aggiuntivo gestione progetti",
    "projectAddonDesc": "Sblocca le funzioni di gestione progetti di Time Pro (lavori extra, pianificazione, gestione subappaltatori)."
  },
  "employees": {
    "title": "Quanti dipendenti?",
    "active": "utenti attivi",
    "popular": "La maggior parte sceglie {{n}}"
  },
  "estimate": "Costo mensile stimato",
  "estimateNote": "IVA esclusa. Tariffe per utente in base ai dipendenti attivi.",
  "estimateUnavailable": "Catalogo prezzi non disponibile. Riprova per caricare i prezzi più recenti."
}
